import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../utils/config/apiClient";
import { toast } from "sonner";
import dedaBg from "../assets/dedaImg/s4 (1).jpg";
import BtnSpinner from "../components/common/btnSpinners";

export default function Signup2() {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    surname: "",
    other_names: "",
    email: "",
    phone_number: "",
    gender: "",
    date_of_birth: "",
    address: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleNext = (e) => {
    e.preventDefault();
    setStep(2);
  };

  const handleBack = () => {
    setStep(1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await apiClient.post(
        "/public/portal?url=auth/register/patient/new",
        formData
      );

      if (response.data) {
        localStorage.setItem("token", response?.data?.token);
        localStorage.setItem("user", JSON.stringify(response?.data));
        setLoading(false);
        toast.success("Account Created");
        localStorage.setItem("localEmail", formData.email);
        navigate("/pages/verify");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Signup failed");
      toast.error(error);
      setLoading(false);
    }
  };

  return (
    <div className="page-sign d-block py-0">
      <Row className="g-0">
        <Col md="7" lg="5" xl="5" className="col-wrapper" style={{ overflowY: "scroll" }}>
          <Card className="card-sign">
            <Card.Header>
              <Link to="/" className="header-logo mb-5">
                Deda
              </Link>
              <Card.Title>Sign Up</Card.Title>
              <Card.Text>It's free to sign up and only takes a minute.</Card.Text>
            </Card.Header>
            <form onSubmit={step === 1 ? handleNext : handleSubmit}>
              <Card.Body>
                {step === 1 ? (
                  <>
                    <div className="mb-3">
                      <Form.Label>Surname</Form.Label>
                      <Form.Control
                        name="surname"
                        value={formData.surname}
                        onChange={handleChange}
                        type="text"
                        placeholder="Enter your surname"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <Form.Label>Other Names</Form.Label>
                      <Form.Control
                        name="other_names"
                        value={formData.other_names}
                        onChange={handleChange}
                        type="text"
                        placeholder="Enter Other Names"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter your email address"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone_number"
                        value={formData.phone_number}
                        onChange={handleChange}
                        placeholder="Enter your phone number"
                        required
                      />
                    </div>
                    <Button variant="success" type="submit" className="btn-sign bg-deda">
                      Next
                    </Button>
                  </>
                ) : (
                  <>
                    <div className="mb-3">
                      <Form.Label>Gender</Form.Label>
                      <Form.Select name="gender" value={formData.gender} onChange={handleChange} required>
                        <option value="">Select your gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </Form.Select>
                    </div>
                    <div className="mb-3">
                      <Form.Label>Date of Birth</Form.Label>
                      <Form.Control
                        type="date"
                        name="date_of_birth"
                        value={formData.date_of_birth}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        rows={3}
                        placeholder="Enter your address"
                        required
                      />
                    </div>
                    <div className="mb-4">
                      <small>
                        By clicking <strong>Create Account</strong> below, you agree to our terms of service and privacy statement.
                      </small>
                    </div>
                    <div className="d-flex gap-4 justify-content-between" >
                      <Button variant="secondary" onClick={handleBack} style={{width:'80px'}}>
                        Back
                      </Button>
                      {/* <div style={}></div> */}
                      <Button variant="primar" type="submit" className="btn-sign bg-deda" >
                        {loading ? <BtnSpinner /> : "Create Account"}
                      </Button>
                    </div>
                  </>
                )}
              </Card.Body>
            </form>
            <Card.Footer>
              Already have an account? <Link to="/pages/signin2" className="text-deda">Sign In</Link>
            </Card.Footer>
          </Card>
        </Col>
        <Col className="d-none d-lg-block">
          <img src={dedaBg} className="auth-img" alt="" />
        </Col>
      </Row>
    </div>
  );
}
